import { z } from "zod";

const nullableText = (maxLength: number) =>
  z.preprocess(
    (value) => (value === "" || value === undefined ? null : value),
    z.string().trim().max(maxLength).nullable(),
  );

const nullableMoney = z.preprocess(
  (value) => (value === "" || value === null || value === undefined ? null : value),
  z.coerce.number().finite().min(0).nullable(),
);

export const orderIdSchema = z.coerce.number().int().positive();

export const orderItemWriteSchema = z
  .object({
    id: orderIdSchema.optional(),
    file_name: nullableText(255),
    file_key: nullableText(512),
    color: z.string().trim().min(1).max(100),
    quantity: z.coerce.number().int().min(1).max(999),
  })
  .strict()
  .refine((item) => Boolean(item.file_name || item.file_key), {
    message: "file_name or file_key is required",
  });

export const orderWriteSchema = z
  .object({
    order_time: nullableText(40),
    xianyu_id: nullableText(100),
    pickup_code: nullableText(40),
    total_price: nullableMoney,
    pickup_time: nullableText(40),
    split_special: nullableMoney,
    notes: nullableText(500),
    items: z.array(orderItemWriteSchema).min(1).max(100),
  })
  .strict();

export const itemPrintPatchSchema = z
  .object({ is_printed: z.boolean() })
  .strict();

export const itemFilePatchSchema = z
  .object({
    file_key: nullableText(512),
    file_name: nullableText(255),
  })
  .strict();

export type OrderWrite = z.infer<typeof orderWriteSchema>;
export type OrderItemWrite = z.infer<typeof orderItemWriteSchema>;
